import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const CasePageLayout = (props: Props) => {
  return (
    <><Outlet /></>
  );
};

export default CasePageLayout;